import { Injectable } from '@angular/core';
// 1. Use HttpClient from the correct module
// 2. Remove Http (old class)
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'; 

// 3. Import Observable and operators from RxJS v7+ structure
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators'; 

import { WishlistAdd, WishlistRemove, WishlistGet } from "../../models/models";
import { RefdataProvider } from '../../providers/refdata/refdata';

@Injectable({
  providedIn: 'root' // Standard in modern Angular setup
})
export class WishlistServiceProvider {

  //TODO = move baseUrl and headers to some kind of config.
  private baseUrl = '';
  private headers = new HttpHeaders({ "x-api-key": "Key1SV0ce45i4Dhrob6VP74IWR45IqRb2wVur7rx" });
  // private options = new RequestOptions({ headers: this.headers });

  constructor(public http: HttpClient, private refdata: RefdataProvider) {
    this.baseUrl = this.refdata.getEnvVar('apiBaseUrl');
  }

  // Helper to configure POST body options using modern HttpClient structure
  private getOptions() {
      return { headers: this.headers };
  }
/*
  addToWishlistOld(wishListRequest: WishlistAdd) {
    let endpoint = "/addtowishlist";
    return this.http.post(this.baseUrl + endpoint, wishListRequest, this.options)
      .timeout(60000)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || "Server error: " + error));
  }
  removeFromWishlist(wishListRequest: WishlistRemove) {
    let endpoint = "/removefromwishlist";
    return this.http.post(this.baseUrl + endpoint, wishListRequest, this.options)
      .timeout(60000)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || "Server error: " + error));
  }

  getWishList(wishListRequest: WishlistGet) {
    let endpoint = "/listwishlist";
    return this.http.post(this.baseUrl + endpoint, wishListRequest, this.options)
      .timeout(60000)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || "Server error: " + error));
  }
*/
  addToWishlist(wishListRequest: WishlistAdd): Observable<any> {
    let endpoint = "/addtowishlist";
    
    // 6. HttpClient returns an Observable. We use RxJS operators (map, catchError) from 'rxjs/operators'.
    return this.http.post(this.baseUrl + endpoint, wishListRequest, this.getOptions())
      .pipe(
        // 7. Standard pipe usage for operators
//        map((res: any) => res.json()), // HttpClient responses are usually JSON, use 'any' or appropriate type.
        catchError((error: any) => {
            // In modern HttpClient, error structure changes. This might need fine-tuning based on your API response for errors.
            const errorBody = error.json ? error.json() : error;
            const serverError = errorBody.error || "Server error";
            return throwError(() => new Error(serverError || "Server error: " + JSON.stringify(error)));
        })
      );
  }

  removeFromWishlist(wishListRequest: WishlistRemove): Observable<any> {
    let endpoint = "/removefromwishlist";
    return this.http.post(this.baseUrl + endpoint, wishListRequest, this.getOptions())
      .pipe(
//        map((res: any) => res.json()),
        catchError((error: any) => {
            const errorBody = error.json ? error.json() : error;
            const serverError = errorBody.error || "Server error";
            return throwError(() => new Error(serverError || "Server error: " + JSON.stringify(error)));
        })
      );
  }

  getWishList(wishListRequest: WishlistGet): Observable<any> {
    let endpoint = "/listwishlist";
    return this.http.post(this.baseUrl + endpoint, wishListRequest, this.getOptions())
      .pipe(
//        map((res: any) => res.json()),
        catchError((error: any) => {
            const errorBody = error.json ? error.json() : error;
            const serverError = errorBody.error || "Server error";
            return throwError(() => new Error(serverError || "Server error: " + JSON.stringify(error)));
        })
      );
  }

}
